import { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { debounce } from 'lodash'

import TextField from '../FormLegacy/FormFieldsV2/TextField'
import InfiniteScroll from '../InfiniteScroll/InfiniteScroll'
import { useClickOutside } from '../../helpers/hooks/useClickOutside'

import DropdownOption from './DropdownOption'

const SelectDropdownInput = ({
  data,
  onSelectOption,
  fetchData,
  isLoadedAll,
  placeholder,
  setLoadingState,
  isLoading,
  dataToRefetch,
  clearAfterSelect,
  isDisabled,
  showSelectedInDropdown,
  selectedValueLabel,
  noResultsText = 'No results',
  clearOnDemand = () => {},
}) => {
  const [searchValue, setSearchValue] = useState('')
  const [prevSearchValue, setPrevSearchValue] = useState('')
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const debounceFn = debounce(fetchData, 1000)
  const ref = useRef()
  useClickOutside(ref, () => {
    setOpenDropdown(false)
  })

  const clearInputIfNeeded = () => {
    if (clearAfterSelect) {
      setSearchValue('')
    }
  }

  const handleOnSelectOption = (item) => {
    onSelectOption(item)
    setOpenDropdown(false)
    clearInputIfNeeded()
    if (showSelectedInDropdown) {
      setSearchValue(item.label)
    }
  }

  useEffect(() => {
    if (prevSearchValue !== searchValue) {
      window.addEventListener('keydown', debounceFn(undefined, searchValue, false, dataToRefetch))
    }
    setPrevSearchValue(searchValue)
    return () => {
      window.removeEventListener('keydown', debounceFn)
    }
  }, [searchValue])

  useEffect(() => {
    fetchData(1, '', false, dataToRefetch)
  }, [dataToRefetch])

  useEffect(() => {
    clearOnDemand(() => () => setSearchValue(''))
  }, [])

  return (
    <div className={`select-option-dropdown ${isDisabled ? 'is-disabled' : ''}`} ref={ref}>
      <TextField
        onClick={() => setOpenDropdown(true)}
        maxLength="30"
        name={'title'}
        placeholder={placeholder}
        onChange={(e) => {
          setSearchValue(e.target.value)
          setLoadingState && setLoadingState(true)
        }}
        value={(!isOpenDropdown && selectedValueLabel) || searchValue}
        autoComplete="new-password"
      />
      <div className={`dropdown-option-list ${isOpenDropdown ? 'visible' : ''}`}>
        {isLoading ? (
          <div>Loading...</div>
        ) : data.length ? (
          <InfiniteScroll
            data={data}
            renderItem={(item) => (
              <DropdownOption
                key={item.value}
                item={item}
                onSelectOption={() => handleOnSelectOption(item)}
              />
            )}
            onEndReached={() => fetchData(undefined, searchValue, true, dataToRefetch)}
            style={{ height: '100%' }}
            isLoadedAll={isLoadedAll}
          />
        ) : (
          <div className="dropdown-option-list__no-results">{noResultsText}</div>
        )}
      </div>
    </div>
  )
}

SelectDropdownInput.propTypes = {
  data: PropTypes.array,
  onSelectOption: PropTypes.func,
  fetchData: PropTypes.func,
  setLoadingState: PropTypes.func,
  isLoadedAll: PropTypes.bool,
  isLoading: PropTypes.bool,
  placeholder: PropTypes.string,
  dataToRefetch: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clearAfterSelect: PropTypes.bool,
  isDisabled: PropTypes.bool,
  showSelectedInDropdown: PropTypes.bool,
  clearOnDemand: PropTypes.func,
  selectedValueLabel: PropTypes.string,
  noResultsText: PropTypes.string,
}

export default SelectDropdownInput
